import { Component } from "@angular/core";
import { IVTableColumn } from "@app/directives/_layout/v-table/_models/IVTableColumn";
import { IVTableRow } from "@app/directives/_layout/v-table/_models/IVTableRow";
import { VTableService } from "@app/directives/_layout/v-table/_services/v-table.service";
import { IFilterBarTab } from "@app/directives/_resourceFilters/filter-bar/filter-bar.models";
import { FilterBarService } from "@app/directives/_resourceFilters/filter-bar/filter-bar.service";
import { SortDirection } from "@app/enum/SortDirection";
import { SortType } from "@app/enum/SortType";
import { VTableSelectionType } from "@app/enum/VTableSelectionType";
import { TranslationService } from "@app/services/translation.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { finalize, tap } from "rxjs/operators";
import { ICameraConfiguration } from "../../_models/ICameraConfiguration";
import { ConfigManagerService } from "../../_services/config.service";
import './config-manager.component.scss';

@UntilDestroy()
@Component({
    selector: 'config-manager',
    template: require('./config-manager.component.html')
})
export class ConfigManagerComponent {

    configFiles: ICameraConfiguration[] = [];
    selectedConfig: ICameraConfiguration;
    selectedConfigs: ICameraConfiguration[] = [];

    tableColumns: IVTableColumn<ICameraConfiguration>[];
    tableRows: IVTableRow[];

    filterTabs: IFilterBarTab<ICameraConfiguration>[];

    VTableSelectionType = VTableSelectionType;

    loading: boolean;

    constructor(
        private readonly configService: ConfigManagerService,
        private readonly filterBarService: FilterBarService,
        private readonly translationService: TranslationService,
        private readonly vTableService: VTableService
    ) { }

    ngOnInit(): void {
        this.createTable();
        this.createTabs();
        this.loadData();
    }

    addNewConfig(): void {
        this.selectedConfig = {
            Id: "",
            Name: "",
            Config: "",
            IsActive: true,
            VersionGroup: null,
            Version: 0
        }
    }

    selectConfig(row: IVTableRow): void {
        this.selectedConfig = row.data;
    }

    clearSelectedConfig(): void {
        this.selectedConfig = null;
    }

    onConfigSaved(config: ICameraConfiguration): void {
        this.loading = true;

        this.configService.saveConfig(config).pipe(
            untilDestroyed(this)
        ).subscribe({
            complete: () => {
                this.clearSelectedConfig();
                this.loading = false
            }
        })
    }


    archiveConfig(confirm: boolean): void {
        if (!confirm) {
            return;
        }
        this.selectedConfig.IsActive = false;
        this.onConfigSaved(this.selectedConfig);
    }

    unarchiveConfig(): void {
        this.selectedConfig.IsActive = true;
        this.onConfigSaved(this.selectedConfig);
    }

    //--

    private loadData(): void {
        this.loading = true;
        this.configService.getConfigs().pipe(
            untilDestroyed(this)
        ).subscribe({
            next: configs => {
                this.configFiles = configs;
                this.createTableRows();
                this.loading = false;
            }
        });
    }

    private createTable(): void {
        this.tableColumns = [
            {
                header: this.vTableService.createDateTableHeader({ tKey: 'Common.Created', sorted: true, sortDirection: SortDirection.Descending }),
                createCellFunction: (config) => this.vTableService.createDateCell(config.CreatedTime)
            },
            {
                header: this.vTableService.createTableHeader({ tKey: 'RVLite.Version', sortType: SortType.Number, width: 150 }),
                createCellFunction: (config) => this.vTableService.createTableCell(config.Version)
            },
            {
                header: this.vTableService.createTableHeader({ tKey: 'Common.Name' }),
                createCellFunction: (config) => this.vTableService.createTableCell(config.Name)
            }
        ]
    }

    private createTableRows(): void {
        this.tableRows = this.vTableService.createTableRows(this.configFiles, this.tableColumns);
    }

    private createTabs(): void {
        this.filterTabs = [];

        this.filterTabs.push(this.filterBarService.createTabDefinition<ICameraConfiguration>("Common.Active", this.isActivePredicate));
        this.filterTabs.push(this.filterBarService.createTabDefinition<ICameraConfiguration>("Common.Archived", this.isInactivePredicate));
    }

    private isActivePredicate = (config) => {
        return config.IsActive;
    }

    private isInactivePredicate = (config) => {
        return !config.IsActive;
    }
}
